import clsx from 'clsx';
import React from 'react';

import ArticleAsset from '@components/FeedItems/ArticleAsset';
import IconProTagArticle from '@components/Images/Rebranding/IconProTagArticle';

import ArticleDetails from '../ArticleDetails';
import Header from '../Header';
import PictureCaption from '../PictureCaption';
import { type ThemeViewsProps, getGatedContent } from '../interfaces';
import styles from '../styles.module.scss';
import Content from './Content';

const Feature = ({
  article,
  env,
  midArticleUnitType,
  mostPopularArticles,
  newsletterId,
  relatedArticles,
  relatedEvent,
}: ThemeViewsProps) => {
  const {
    advertisement,
    authors,
    freeBlurb,
    highlight,
    id,
    isPro,
    pickups,
    picture,
    pictureCaption,
    pictureLink,
    publishedAt,
    scriptList,
    subTitle,
    title,
  } = article;

  const { fullText, takeaway, addendum } = getGatedContent(article);

  const articleAsset = (
    <ArticleAsset title={title} id={id} picture={picture} env={env} isFeaturedArticle />
  );
  return (
    <>
      <figure className="relative m-auto h-[calc(100vw*(9/16))]" aria-labelledby="caption-text">
        {isPro && <IconProTagArticle className="absolute right-0 top-0 w-[65px] sm:w-[119px]" />}
        {pictureLink ? <a href={pictureLink}>{articleAsset}</a> : articleAsset}
      </figure>
      <div className="px-16 sm:px-28">
        <div
          className={clsx('relative m-auto lg:max-w-[1060px] xl:max-w-container-lg', {
            'mb-80 sm:mb-112': !!midArticleUnitType && article.access !== 'locked',
          })}
        >
          <div
            className={clsx(
              styles.headerContainer,
              'absolute -left-36 -top-[92px] z-0 hidden h-[320px] bg-white lg:block lg:w-[844px] xl:w-[1012px] dark:bg-[var(--white)]'
            )}
          />
          <div className="relative z-[1] flex flex-col-reverse lg:flex-row lg:gap-72 xl:gap-112">
            <div className="flex-1 pt-28 sm:pt-48 lg:-mt-[92px] lg:pt-24">
              <Header highlight={highlight} title={title} subTitle={subTitle} />
              <div className="mb-40 mt-12 sm:my-48 md:mb-64">
                <ArticleDetails authors={authors} publishedAt={publishedAt} articleId={id} />
              </div>
            </div>
            <PictureCaption pictureCaption={pictureCaption} />
          </div>
          <Content
            access={article.access}
            addendum={addendum}
            advertisement={advertisement}
            authors={authors}
            bodyClassName={styles.isFeature}
            env={env}
            freeBlurb={freeBlurb}
            fullText={fullText}
            highlight={highlight}
            id={id}
            midArticleUnitType={midArticleUnitType}
            mostPopularArticles={mostPopularArticles}
            newsletterId={newsletterId}
            picture={picture}
            pickups={pickups}
            relatedArticles={relatedArticles}
            relatedEvent={relatedEvent}
            scriptList={scriptList}
            takeaway={takeaway}
          />
        </div>
      </div>
    </>
  );
};

export default Feature;
